import { useEffect, useState } from "react";
import { fetchEvents } from "../lib/api";
import { Hero } from "../components/site/Hero";
import { Manifesto } from "../components/site/Manifesto";
import { EventCards } from "../components/site/EventCards";
import { Packages } from "../components/site/Packages";
import { FadeUp } from "../components/site/RevealText";
import { ArrowUpRight } from "lucide-react";
import { FALLBACK_TICKET_URL } from "../lib/api";
import { useLang, T } from "../lib/i18n";

export default function Home({ settings }) {
  const [events, setEvents] = useState([]);
  const { lang } = useLang();
  const t = T[lang];

  useEffect(() => {
    fetchEvents().then(setEvents).catch(() => {});
  }, []);

  const url = settings?.ticket_url || FALLBACK_TICKET_URL;

  return (
    <div data-testid="home-page">
      <Hero settings={settings} />
      <Manifesto />
      <EventCards events={events} ticketUrl={url} />
      <Packages ticketUrl={url} />

      <section data-testid="final-cta-section" className="relative overflow-hidden">
        <img
          src="https://customer-assets-gfyr7b9c.emergentagent.net/job_caribbean-nye/artifacts/aefqvt0q_0461eb5084b1c686035cd4d174997ab31c42bb95-1600x1066.jpg"
          alt="Anse Marcel bay, Saint Martin"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0B2530]/55" />
        <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 py-32 md:py-48 text-center">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.3em] text-[#7BDFF2] mb-6">{t.finalCta.kicker}</p>
            <h2 className="font-serif text-white text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.02] max-w-4xl mx-auto">
              {t.finalCta.title1} <span className="italic">{t.finalCta.titleAccent}</span>
            </h2>
            <a
              href={url}
              target="_blank"
              rel="noopener"
              data-testid="final-cta-buy-tickets"
              className="group mt-12 inline-flex items-center gap-3 rounded-full bg-white text-slate-900 hover:bg-[#7BDFF2] text-sm uppercase tracking-[0.2em] px-10 py-5 transition-colors duration-300"
            >
              {t.finalCta.buy}
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
